import React from 'react'

import Link from 'next/link'

import { Text } from 'Components/UI'

import { PRIVACY_POLICY, TERMS_CONDITIONS } from 'Constants/Paths'

import { useResponsiveLayout } from 'Hooks'

import { Container, Divider } from './styles'

function Bottom() {
  const { isMobile } = useResponsiveLayout()

  return (
    <Container flexDirection={['column', 'column', 'row']}>
      <Text inverse medium screen14>
        © {new Date().getFullYear()} Emajin Golf
      </Text>

      {!isMobile && <Divider />}

      <Link href={TERMS_CONDITIONS}>
        <Text inverse medium screen14>
          Terms & Conditions
        </Text>
      </Link>

      {!isMobile && <Divider />}

      <Link href={PRIVACY_POLICY}>
        <Text inverse medium screen14>
          Privacy Policy
        </Text>
      </Link>
    </Container>
  )
}

export default Bottom
